<template>
  <div class="col-12 px-0 mt-2">
    <form
      @submit.prevent="createToken"
      novalidate
      class="needs-validation d-flex mb-3 pt-3 p-1 p-sm-3 bg-lighter border-top"
    >
      <div class="align-items-start d-flex flex-wrap w-100">

        <div class="px-md-3 mb-3 col-12 col-md-6 col-lg-4">
          <div class="form-group">
            <label for="tokenName">Token name</label>
            <input
              id="tokenName"
              v-model.trim="form.name"
              type="text"
              required
              :class="[
                'form-control',
                errors.name ? 'is-invalid' : ''
              ]"
              placeholder="Enter token name"
            >
            <div class="invalid-feedback" v-if="errors.name">
              {{ errors.name[0] }}
            </div>
          </div>
        </div>

        <div class="form-group col-12 col-lg-auto px-lg-0">
          <label aria-hidden="true" class="w-100 d-none d-lg-block">&nbsp;</label>
          <button
            type="submit"
            :disabled="processing"
            :class="[
              'btn btn-block-mob mt-auto',
              processing ? 'btn-primary-dark' : 'btn-outline-primary'
            ]"
          >
            <span v-if="!processing">Create token</span>
            <div v-else class="spinner-border text-light" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </button>
        </div>

      </div>
    </form>

    <div v-if="createdToken" class="alert alert-success mt-3">
      <strong>Token created:</strong>
      <div class="mt-2">
        <code>{{ createdToken }}</code>
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          @click="copyToken"
        >
          Copy
        </button>
      </div>
      <small class="text-muted d-block mt-1">
        Copy this token now. You won’t be able to see it again.
      </small>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      form: {
        name: ''
      },
      processing: false,
      errors: {},
      createdToken: null
    }
  },
  methods: {
    async createToken() {
      this.processing = true
      this.errors = {}
      this.createdToken = null

      try {
        const response = await axios.post(`${this.$api}/admin/api-tokens`, this.form)

        if (response.data.status === 'success') {
          this.createdToken = response.data.data.token
          this.$emit('created', response.data.data.token)
          this.form.name = ''
        } else {
          this.errors = response.data.errors || {}
          this.$emit('error', response.data.error || 'Unable to receive data from the server. Please reload the page.')
        }
      } catch (error) {
        this.$emit('error', error)
      } finally {
        this.processing = false
      }
    },
    copyToken() {
      if (!this.createdToken) return
      navigator.clipboard.writeText(this.createdToken)
        .then(() => {
          this.$emit('success', 'Token copied!')
        })
        .catch(() => {
          // alert('Failed to copy token.')
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/ApiTokens/Add/TokenAdd.vue